import Graph from "../../../components/graphs/Graph";
import GraphAxesDisplayOptions from "../../../components/graphs/GraphAxesDisplayOptions";
import GraphAxisDisplayOptions from "../../../components/graphs/GraphAxisDisplayOptions";
import GraphAxisIntervalDisplayOptions from "../../../components/graphs/GraphAxisIntervalDisplayOptions";
import GraphAxisLegendDisplayOptions from "../../../components/graphs/GraphAxisLegendDisplayOptions";
import LineGraphDisplayOptions from "../../../components/graphs/LineGraphDisplayOptions";
import Vector2 from "../../../components/graphs/Vector2";
import DashboardSingleData from "../../model/DashboardSingeData";
import DashboardTabMediator from "./DashboardTabMediator";
export default class DashboardEpiTabMediator extends DashboardTabMediator {
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, dashboardNumberChartFactory, dashboardConfig) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
        this._dashboardNumberChartFactory = dashboardNumberChartFactory;
        this._languagePack = languagePack;
        this._dashboardConfig = dashboardConfig;
        this._numberCharts = [];
    }

    initialize() {
        super.initialize();
        this._initializeNumberCharts();
        this._initializeGraphs();
        this._localiseTexts();
    }

    _initializeNumberCharts() {
        //Todo: Refactor during data import process
        const dashboardConfig = this._dashboardConfig.dashboard;

        let dataSetNumbers = [
            new DashboardSingleData(this._languagePack.getText("dashboard.epiTab.numberCharts.numberSuspectedCases"), "65", 0, true, false),
            new DashboardSingleData(this._languagePack.getText("dashboard.epiTab.numberCharts.numberConfirmedCases"), "16", 0, true, false),
            new DashboardSingleData(this._languagePack.getText("dashboard.epiTab.numberCharts.numberRecoveredCase"), "13", 0, true, true),
            new DashboardSingleData(this._languagePack.getText("dashboard.epiTab.numberCharts.numberTestsConducted"), "20", 0, true, true),
            new DashboardSingleData(this._languagePack.getText("dashboard.epiTab.numberCharts.positivityRate"), "80%", 0, true, false),
            new DashboardSingleData(this._languagePack.getText("dashboard.epiTab.numberCharts.suspectedDeaths"), "8", 0, true, false),
            new DashboardSingleData(this._languagePack.getText("dashboard.epiTab.numberCharts.confirmedDeaths"), "9", 0, true, false),
            new DashboardSingleData(this._languagePack.getText("dashboard.epiTab.numberCharts.ITCBedOccupancy"), "33%", 0, true, false)
        ];

        var self = this;
        dataSetNumbers.forEach(function (dashboardSingleData, index) {
            var numberChart = self._dashboardNumberChartFactory.createNumberChart(self._target["DataElement" + (index + 1)]);
            numberChart.setData(dashboardSingleData, false);
            self._numberCharts.push(numberChart);
        });
    }

    _initializeGraphs() {

        let dataSetExampleIndex = 1;

        let adjustmentConfigurationGraph = [
            {
                scalesGraph1: [26, 0.6],
                scalesGraph2: [26, 5],
                intervalGraph1: [1, 50],
                intervalGraph2: [1, 5],
                minimumBoundariesGraph1: new Vector2(19, 0),
                minimumBoundariesGraph2: new Vector2(19, 0),
            },
            {
                scalesGraph1: [26, 5],
                scalesGraph2: [26, 6],
                intervalGraph1: [1, 5],
                intervalGraph2: [1, 5],
                minimumBoundariesGraph1: new Vector2(19, 0),
                minimumBoundariesGraph2: new Vector2(19, 0),
            }
        ];

        let dataSet = [
            //full
            [
                [
                    //Path AAA Number of Suspected Cases
                    new Vector2(2, 23),
                    new Vector2(3, 20),
                    new Vector2(4, 65),
                    new Vector2(5, 146),
                    new Vector2(6, 181),
                    new Vector2(7, 213),
                    new Vector2(8, 218),
                    new Vector2(9, 210),
                    new Vector2(10, 202),
                    new Vector2(11, 197),
                    new Vector2(12, 188),
                    new Vector2(13, 179),
                    new Vector2(14, 170),
                    new Vector2(15, 162),
                    new Vector2(19, 129),
                ],
                [
                    //Path AAA Number of Confirmed Cases
                    new Vector2(2, 11),
                    new Vector2(3, 18),
                    new Vector2(4, 34),
                    new Vector2(5, 29),
                    new Vector2(6, 24),
                    new Vector2(7, 32),
                    new Vector2(8, 23),
                    new Vector2(9, 29),
                    new Vector2(10, 25),
                    new Vector2(11, 33),
                    new Vector2(12, 27),
                    new Vector2(13, 19),
                    new Vector2(14, 26),
                    new Vector2(15, 22),
                    new Vector2(19, 17),
                ]
            ],
            //small
            [
                [
                    //Path AAA Number of Suspected Cases
                    new Vector2(2, 23),
                ],
                [
                    //Path AAA Number of Confirmed Cases
                    new Vector2(2, 11),
                ]
            ]
        ];


        this._lineGraph = new Graph(
            this._target.Graph1,
            dataSet[dataSetExampleIndex][0],
            adjustmentConfigurationGraph[dataSetExampleIndex].minimumBoundariesGraph1,
            {
                lineGraphDisplayOptions: new LineGraphDisplayOptions(
                    "#324141",
                    7,
                    3
                ),
                graphAxesDisplayOptions: new GraphAxesDisplayOptions(
                    new GraphAxisDisplayOptions(
                        true,
                        "#194a77",
                        3,
                        adjustmentConfigurationGraph[dataSetExampleIndex].scalesGraph1[0],
                        new GraphAxisLegendDisplayOptions(true, "Week", "#2c3c3c", 35, "18px", "'Work Sans'"),
                        new GraphAxisIntervalDisplayOptions(true, adjustmentConfigurationGraph[dataSetExampleIndex].intervalGraph1[0], "#2c3c3c", 7, false, "black", 1, "18px", "'Work Sans'"),
                    ),
                    new GraphAxisDisplayOptions(
                        false,
                        "#194a77",
                        3,
                        adjustmentConfigurationGraph[dataSetExampleIndex].scalesGraph1[1],
                        new GraphAxisLegendDisplayOptions(false),
                        new GraphAxisIntervalDisplayOptions(true, adjustmentConfigurationGraph[dataSetExampleIndex].intervalGraph1[1], "#2c3c3c", 7, true, "#2c3c3c", 1, "18px", "'Work Sans'"),
                    ),
                )
            }
        );



        this._lineGraph = new Graph(
            this._target.Graph2,
            dataSet[dataSetExampleIndex][1],
            adjustmentConfigurationGraph[dataSetExampleIndex].minimumBoundariesGraph2,
            {
                lineGraphDisplayOptions: new LineGraphDisplayOptions(
                    "#324141",
                    7,
                    3
                ),
                graphAxesDisplayOptions: new GraphAxesDisplayOptions(
                    new GraphAxisDisplayOptions(
                        true,
                        "#194a77",
                        3,
                        adjustmentConfigurationGraph[dataSetExampleIndex].scalesGraph2[0],
                        new GraphAxisLegendDisplayOptions(true, "Week", "#2c3c3c", 35, "18px", "'Work Sans'"),
                        new GraphAxisIntervalDisplayOptions(true, adjustmentConfigurationGraph[dataSetExampleIndex].intervalGraph2[0], "#2c3c3c", 7, false, "black", 1, "18px", "'Work Sans'"),
                    ),
                    new GraphAxisDisplayOptions(
                        false,
                        "#194a77",
                        3,
                        adjustmentConfigurationGraph[dataSetExampleIndex].scalesGraph2[1],
                        new GraphAxisLegendDisplayOptions(false),
                        new GraphAxisIntervalDisplayOptions(true, adjustmentConfigurationGraph[dataSetExampleIndex].intervalGraph2[1], "#2c3c3c", 7, true, "#2c3c3c", 1, "18px", "'Work Sans'"),
                    ),
                )
            }
        );
    }

    _localiseTexts() {
        this._target.LabelTab1.text = this._languagePack.getText(`dashboard.epiTab.legendTab`);
        this._target.LabelGraph1.text = this._languagePack.getText(`dashboard.epiTab.legendGraph1`);
        this._target.LabelGraph2.text = this._languagePack.getText(`dashboard.epiTab.legendGraph2`);
    }

    destroy() {
        super.destroy();
        for (let i = 0; i < this._numberCharts.length; i++) {
            const numberChart = this._numberCharts[i];
            numberChart.destroy();
        }

        this._numberCharts = [];
        this._target.removeAllChildren();
    }
    get skin() {
        return this._target;
    }

    get keyDecision() {
        return this._keyDecision;
    }
}